import { render, staticRenderFns } from "./delete-modal.html?vue&type=template&id=053e1327&"
import script from "./delete-modal.js?vue&type=script&lang=js&"
export * from "./delete-modal.js?vue&type=script&lang=js&"
import style0 from "../../main.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports